export const ContactDetails = ({ contactCount, singleText, multipleText }: { contactCount: number; singleText: string; multipleText: string }) => (
    <p className="bg-white rounded-lg inline-block mb-4 py-2 px-3">
        {' '}
        <span className="text-3xl"> {contactCount} </span> {contactCount === 1 ? singleText : multipleText}{' '}
    </p>
);
